function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f8f8f8",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 23.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 22
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.094 16.803c.02.273.02.547.02.82 0 8.34-6.348 17.949-17.949 17.949a17.828 17.828 0 01-9.688-2.831 13.048 13.048 0 001.523.078 12.634 12.634 0 007.832-2.7 6.32 6.32 0 01-5.9-4.375 7.955 7.955 0 001.191.1 6.673 6.673 0 001.66-.215 6.309 6.309 0 01-5.056-6.189v-.078a6.353 6.353 0 002.852.8 6.318 6.318 0 01-1.953-8.437 17.932 17.932 0 0013.008 6.6 7.122 7.122 0 01-.157-1.443 6.315 6.315 0 0110.918-4.316 12.42 12.42 0 004-1.523 6.292 6.292 0 01-2.773 3.477 12.647 12.647 0 003.633-.977 13.561 13.561 0 01-3.161 3.26z",
  fill: "#f8f8f8"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NyIgaGVpZ2h0PSI0NyIgdmlld0JveD0iMCAwIDQ3IDQ3Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE5NyAtNDM5MSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExOTcgNDM5MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2Y4ZjhmOCIgc3Ryb2tlLXdpZHRoPSIzIj48Y2lyY2xlIGN4PSIyMy41IiBjeT0iMjMuNSIgcj0iMjMuNSIgc3Ryb2tlPSJub25lIi8+PGNpcmNsZSBjeD0iMjMuNSIgY3k9IjIzLjUiIHI9IjIyIiBmaWxsPSJub25lIi8+PC9nPjxwYXRoIGQ9Ik0yNy42MTcsNTQuMzEyYy4wMi4yNzMuMDIuNTQ3LjAyLjgyLDAsOC4zNC02LjM0OCwxNy45NDktMTcuOTQ5LDE3Ljk0OUExNy44MjgsMTcuODI4LDAsMCwxLDAsNzAuMjVhMTMuMDQ4LDEzLjA0OCwwLDAsMCwxLjUyMy4wNzgsMTIuNjM0LDEyLjYzNCwwLDAsMCw3LjgzMi0yLjcsNi4zMiw2LjMyLDAsMCwxLTUuOS00LjM3NSw3Ljk1NSw3Ljk1NSwwLDAsMCwxLjE5MS4xLDYuNjczLDYuNjczLDAsMCwwLDEuNjYtLjIxNUE2LjMwOSw2LjMwOSwwLDAsMSwxLjI1LDU2Ljk0OXYtLjA3OGE2LjM1Myw2LjM1MywwLDAsMCwyLjg1Mi44LDYuMzE4LDYuMzE4LDAsMCwxLTEuOTUzLTguNDM3LDE3LjkzMiwxNy45MzIsMCwwLDAsMTMuMDA4LDYuNkE3LjEyMiw3LjEyMiwwLDAsMSwxNSw1NC4zOTFhNi4zMTUsNi4zMTUsMCwwLDEsMTAuOTE4LTQuMzE2LDEyLjQyLDEyLjQyLDAsMCwwLDQtMS41MjMsNi4yOTIsNi4yOTIsMCwwLDEtMi43NzMsMy40NzcsMTIuNjQ3LDEyLjY0NywwLDAsMCwzLjYzMy0uOTc3QTEzLjU2MSwxMy41NjEsMCwwLDEsMjcuNjE3LDU0LjMxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMDUuNDc3IDQzNTMuNDkxKSIgZmlsbD0iI2Y4ZjhmOCIvPjwvZz48L3N2Zz4=";
export { SvgTwitter as ReactComponent };